import React from "react";

import { Route, Routes } from "react-router-dom";

// import NotFound from './testPages/NotFound.js'
import PatientLogin from "./pages/patient/PatientLogin";
import Resultat from "./pages/patient/Resultat";
import PatientDashboard from "./pages/patient/PatientDashboard";
import MedecinDashboard from "./pages/medecinPS/MedecinDashboard";
import MedecinSLogin from "./pages/medecinPS/MedecinSLogin";
import Home from "./pages/Home";
import Pdf from "./components/Pdf";

export default function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/patient" element={<PatientDashboard />} />
        <Route path="/medecinPS" element={<MedecinDashboard />} />
        <Route path="/loginPatient" element={<PatientLogin />} />
        <Route path="/loginMedecinPS" element={<MedecinSLogin />} />
        <Route
          path="/resultat/:id_depot/:saisie/:valid/:depot_analyse_valid/:reste/:tous_signee/:reste_p_auto_print/:auto_print_reste_p"
          element={<Resultat />}
        />

        <Route path="/pdf" element={<Pdf />} />
      </Routes>
    </div>
  );
}
